import script from "./VehicleStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleStatus.vue?vue&type=script&setup=true&lang=js"

import "./VehicleStatus.vue?vue&type=style&index=0&id=3e46716c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e46716c"]])

export default __exports__